import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { getUser, fetchLoggedInUser } from 'src/user';
import { getToken } from 'src/auth';
import { setBreadcrumbs, reduceServerErrors, UiToastAdapter } from 'src/ui';

import { Card, Columns, Column, MuiTitle } from 'src/ui/mui-ui-kit';;
import { CheckTree, Button } from 'rsuite';
import { fetchAccount, getAccount } from 'src/account';
import { toast } from 'react-toastify';
import { Navigate } from 'react-router-dom';
import { updateAccountPerson } from '../../account';
import { AllowedReportsTable } from '../components/AllowedReportsTable';

function PeopleAllowedReportsPage({
  setBreadcrumbs,
  fetchLoggedInUser,
  token,
  user,
  account,
  updateAccountPerson,
}) {
  const [people, setPeople] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedPerson, setSelectedPerson] = React.useState(
    account.people[0] || {}
  );
  const [isAdmin, setIsAdmin] = React.useState(
    user.isAdmin ||
      user.isBankAdmin ||
      user.isSuperAdmin ||
      user.isMerchantAdmin
  );
  const [refresh, setRefresh] = React.useState(false);
  React.useEffect(() => {
    (async () => {
      if (token.isValid()) {
        if (!user.isValid()) {
          await fetchLoggedInUser();
        }
        if (user.accountId) {
          await fetchAccount(user.accountId);
          setIsAdmin(
            user.isAdmin ||
              user.isBankAdmin ||
              user.isSuperAdmin ||
              user.isMerchantAdmin
          );
          setPeople(account.people);
          setBreadcrumbs([
            { label: 'People', href: '/people' },
            { label: 'Allowed Reports', href: '/people/allowed-reports' },
          ]);
          setLoading(false);
          if (account.isError()) {
            reduceServerErrors(account);
          }
        }
      }
    })();
  }, [refresh]);

  const handleSubmit = async (checkedValues, personId, accountId) => {
    const person = {
      ...selectedPerson,
      allowedReports: checkedValues,
      personId,
      accountId,
    };
    await updateAccountPerson(person);
    if (account.isError()) {
      setLoading(false);
      reduceServerErrors(account);
    }
    toast(UiToastAdapter('Allowed Reports updated successfully', 'success'));
    setRefresh(!refresh);
  };
  if (!isAdmin) {
    return <Navigate to="/people" replace />;
  }
  return (
    <>
      <Columns>
        <Column>
          <MuiTitle isSize={4} hasTextColor="info" tag="h2">
            Allowed Reports
          </MuiTitle>
          <AllowedReportsTable
            loading={loading}
            people={people}
            setSelectedPerson={setSelectedPerson}
            selectedPerson={selectedPerson}
          />
        </Column>
        <Column>
          <MuiTitle
            isSize={4}
            hasTextColor="info"
            tag="h2"
          >{`${selectedPerson.firstName} ${selectedPerson.lastName}'s Allowed Reports`}</MuiTitle>
          <MultiSelectReports
            selectedPerson={selectedPerson}
            accountId={user.accountId}
            handleSubmit={handleSubmit}
          />
        </Column>
      </Columns>
    </>
  );
}

function mapStateToProps(state) {
  return {
    token: getToken(state),
    user: getUser(state),
    account: getAccount(state),
  };
}

const connectedAllowedReportsPage = connect(mapStateToProps, {
  fetchLoggedInUser,
  fetchAccount,
  setBreadcrumbs,
  updateAccountPerson,
})(PeopleAllowedReportsPage);

PeopleAllowedReportsPage.propTypes = {
  token: propTypes.object.isRequired,
  user: propTypes.object.isRequired,
  account: propTypes.object.isRequired,
  setBreadcrumbs: propTypes.func.isRequired,
  fetchLoggedInUser: propTypes.func.isRequired,
  updateAccountPerson: propTypes.func.isRequired,
};
const MultiSelectReports = ({ selectedPerson, accountId, handleSubmit }) => {
  const reportTypes = [
    { label: 'Transactions', value: 'Transactions' },
    { label: 'Processing Statements', value: 'Processing Statements' },
    { label: 'Point of Sale Reports', value: 'Point of Sale Reports' },
    { label: 'Deposits', value: 'Deposits' },
    { label: 'Daily Tips', value: 'Daily Tips' },
    { label: 'Summary Tips', value: 'Summary Tips' },
    { label: 'Batch', value: 'Batch' },
    { label: 'Refunds', value: 'Refunds' },
    // { label: 'Performers', value: 'Performers' },
  ];
  const [checkedValues, setCheckedValues] = React.useState([]);
  const [disabled, setDisabled] = React.useState(true);

  React.useEffect(() => {
    setCheckedValues([]);
    setDisabled(true);
    if (selectedPerson.allowedReports) {
      setCheckedValues(() => selectedPerson.allowedReports);
    }
  }, [selectedPerson]);
  const handleChange = value => {
    setCheckedValues(value);
    setDisabled(false);
  };
  const handleClick = () => {
    const personId = selectedPerson.id;
    handleSubmit(checkedValues, personId, accountId);
    setDisabled(true);
  };
  return (
    <>
      <Card style={{ width: 350, paddingTop: '1em', paddingBottom: '1em' }}>
        <CheckTree
          className="text"
          data={reportTypes}
          value={checkedValues}
          onChange={handleChange}
          style={{ height: '30%', paddingBottom: '.5em' }}
        />
        <Button
          style={{ marginLeft: '1em' }}
          appearance="primary"
          size="md"
          onClick={handleClick}
          disabled={disabled}
        >
          Submit
        </Button>
      </Card>
    </>
  );
};

MultiSelectReports.propTypes = {
  selectedPerson: propTypes.object.isRequired,
  handleSubmit: propTypes.func.isRequired,
  accountId: propTypes.number.isRequired,
};
export { connectedAllowedReportsPage as PeopleAllowedReportsPage };
